<template>
  <div class="relative w-full flex">
    <div class="absolute inset-y-0 left-0 flex items-center pl-3.5">
      <SearchLg class="w-5 h-5 text-placeholder" aria-hidden="true" />
    </div>
    <input
      class="w-full py-3 md:py-2.5 px-10 border-primary rounded-md text-base font-normal placeholder:text-placeholder"
      v-model="value"
      :placeholder="t('components.buttons.search')"
      type="text"
      name="search"
      id="search"
      @click.stop
    />
    <div
      v-show="value"
      class="absolute inset-y-0 right-0 flex items-center px-3.5"
      @click.stop="value = ''"
    >
      <XClose
        class="w-5 h-5 text-placeholder hover:fg-quinary_hover transition-colors cursor-pointer"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, watchEffect } from "vue";
import { debounce } from "vue-debounce";
import { useI18n } from "vue-i18n";
import { SearchLg, XClose } from "@/Icons";

const { t } = useI18n();

const emit = defineEmits(["input"]);

const props = defineProps({
  query: { type: String, default: "" },
  debounceMs: { type: Number, default: 500 },
});

const value = ref(props.query);

watchEffect(() => {
  value.value = props.query;
});

const onValueChange = debounce((newValue) => {
  emit("input", newValue);
}, props.debounceMs);

watch(value, () => {
  if (!value.value) {
    emit("input", "");
  }
  onValueChange(value.value);
});
</script>
